import type { DialogType } from '../../../../@types';
import type { WelcomeBonusCampaign } from '../../../../@types/api';
import { useModal } from '../../../../contexts/ModalContext';
import CreateWelcomeBonusForm from './CreateWelcomeBonusForm';
import EditWelcomeBonusForm from './EditWelcomeBonusForm';

const WelcomeBonusForm = ({ closeModal }: DialogType) => {
  const { item } = useModal<WelcomeBonusCampaign>();

  return item ? (
    <EditWelcomeBonusForm campaign={item} closeModal={closeModal} />
  ) : (
    <CreateWelcomeBonusForm closeModal={closeModal} />
  );
};

export default WelcomeBonusForm;
